module.exports = "<div class=\"pill\">\n  {{skill}}\n</div>"